(function () {
  const NEW_TEXT = "In den Warenkorb";

  // robust: findet die echten Add-to-cart Buttons in Shopify Themes (u.a. Dawn & viele andere)
  const SELECTORS = [
    'form[action^="/cart/add"] button[type="submit"]',
    'form[action^="/cart/add"] button[name="add"]',
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    '.product-form__submit',
    '.product-form button[type="submit"]',
    '.shopify-payment-button__button--unbranded' // falls Theme hier mischt
  ].join(",");

  function cleanNodeText(node) {
    // Entfernt Middle Dot & ähnliche Trenner als echtes Zeichen im Text
    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        child.nodeValue = child.nodeValue
          .replace(/\s*·\s*/g, " ")
          .replace(/\s*\u00B7\s*/g, " ") // · explicit
          .replace(/\s*\u2022\s*/g, " ") // •
          .replace(/\s*\u2219\s*/g, " ") // ∙
          .replace(/\s*\|\s*/g, " ");
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        cleanNodeText(child);
      }
    });
  }

  function removePriceParts(btn) {
    // 1) data-button-price Attribute/Elemente
    btn.removeAttribute("data-button-price");
    btn.querySelectorAll("[data-button-price]").forEach(el => el.remove());

    // 2) Häufige Price/Separator Klassen (Themes/Apps)
    btn.querySelectorAll(
      ".price, .button-price, .price-item, .price__regular, .price__sale, .separator, .dot, .middot, .delimiter"
    ).forEach(el => el.remove());

    // 3) Wenn Preis als Text drinsteht (z.B. "€", "EUR", "CHF") -> entfernen wir diese Teile
    // (wir lassen nur den neuen Text übrig)
    // Das ist absichtlich “hart”, damit wirklich *kein* Preis/Separator bleibt:
    btn.textContent = NEW_TEXT;
  }

  function fixButtons(root) {
    (root || document).querySelectorAll(SELECTORS).forEach((btn) => {
      // Nur Buttons, die wirklich "Add to cart" sein sollen:
      // Wir filtern Checkout/Buy-now Buttons aus
      const t = (btn.textContent || "").toLowerCase();
      if (t.includes("buy now") || t.includes("jetzt kaufen") || t.includes("checkout") || t.includes("zur kasse")) return;

      // Text setzen
      btn.setAttribute("data-add-to-cart-text", NEW_TEXT);

      // Preis/Separatoren entfernen
      removePriceParts(btn);

      // Falls irgendwo noch ein Middle-Dot als Textnode hängt (z.B. durch Apps)
      cleanNodeText(btn);
    });
  }

  // initial
  document.addEventListener("DOMContentLoaded", () => fixButtons(document));

  // bei dynamischen Updates (Quick add, Drawer, AJAX)
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) fixButtons(n);
      });
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
